import { writable } from 'svelte/store';

export const availableRatingsStore = writable([]);

export const availableIndexesStore = writable([]);
